module.exports = __webpack_public_path__ + "static/media/4lml2.1882e4f6.png";